import keycode from "keycode";
import { isElectron } from "../utils/env-utils";

let handlers = [];

const EVENT_DEBUG = true;
const debugEvent = (type) => (message) => {
  EVENT_DEBUG ? console.log(`%c[Key Event watched in ${type}]%c ${message}`, "color:blue", "") : null;
};

document.addEventListener("keydown", (event) => {
  handlers.forEach(({ condition, action }) => {
    if (condition(event)) action();
  });
});

let _actions = [];

// TODO:
// 1. Event 흐름을 다시 써봐야 할듯
// 2. 이 부분만 리팩터링이 필요함

// 여기를 라이브러리를 써서 좀 다듬어야 할듯
// shortcut record 기능도 필요하니까
export default class EventExposure {
  // Register

  static register(actions = []) {
    this.removeAll();

    // electron environment
    if (isElectron()) {
      this.registerToElectron(actions);
    } else {
      this.registerToWindow(actions);
    }
  }

  static registerToWindow(actions) {
    // browser environment
    handlers = actions
      .filter(({ shortcutKey }) => shortcutKey)
      .map(({ shortcutKey, action }) => {
        const modifiers = [];
        const keys = [];
        shortcutKey.split("+").forEach((key) => {
          if (key === "ctrl" || key === "alt" || key === "shift") {
            modifiers.push(key);
          } else {
            keys.push(key);
          }
        });

        return {
          shortcutKey,
          condition: (event) => {
            // TODO: debounce
            // console.log(event.metaKey); // command Key

            return (
              event.ctrlKey === modifiers.includes("ctrl") &&
              event.altKey === modifiers.includes("alt") &&
              event.shiftKey === modifiers.includes("shift") &&
              keys.includes(keycode(event))
            );
          },
          action: () => {
            debugEvent("WINDOW")(shortcutKey);
            action();
          },
        };
      });
  }

  static registerToElectron(actions) {
    const CHANNEL_KEY = "_v6t_channel";

    _actions = [...actions];

    const enhancedActions = actions.map(({ actionId, shortcutKey, action }) => {
      return {
        actionId,
        shortcutKey,
        script: `
          try {
            window.${CHANNEL_KEY}("${shortcutKey}");
          } catch (e) {
            console.error(e)
          }
        `,
      };
    });

    window._V6T.registerShortcuts(JSON.stringify(enhancedActions));

    window[CHANNEL_KEY] = (shortcutKey) => {
      debugEvent("ELECTRON")(shortcutKey);
      _actions.find(({ shortcutKey: _shortcutKey }) => _shortcutKey === shortcutKey).action();
    };
  }

  // REMOVE ALL

  static removeAll() {
    if (isElectron()) {
      this.removeAllFromElectron();
    } else {
      this.removeAllFromWindow();
    }
  }

  static removeAllFromWindow() {
    handlers = [];
  }

  static removeAllFromElectron() {
    window._V6T.removeAllShortcuts();
  }

  // REMOVE

  static remove(shortcutKey) {
    if (isElectron) {
      //
    } else {
      handlers = handlers.filter((handler) => handler.shortcutKey !== shortcutKey);
    }
  }
}
